function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
        return 0;
    }
    const numString = (number / 100.0).toFixed(precision);
    const parts = numString.split(".");
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    const cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
}

export const MoneyFormats = Object.freeze({
    MONEY_WITH_CURRENCY: window.Currency.money_format_currency,
    MONEY_WITHOUT_CURRENCY: window.Currency.money_format_no_currency,
});

export function formatMoney(cents, format = MoneyFormats.MONEY_WITHOUT_CURRENCY) {
    const placeholderRegex = /{{\s*(\w+)\s*}}/;
    return format.replace(placeholderRegex, formatWithDelimiters(cents, 0)); //TODO: it's a workaround, since Shopify doesn't support custom formatting across Markets

    // return format.replace(placeholderRegex, (match, placeholder) => {
    //   switch (placeholder) {
    //     case "amount":
    //       return formatWithDelimiters(cents, 2);
    //     case "amount_no_decimals":
    //       return formatWithDelimiters(cents, 0);
    //     case "amount_with_comma_separator":
    //       return formatWithDelimiters(cents, 2, ".", ",");
    //     case "amount_no_decimals_with_comma_separator":
    //       return formatWithDelimiters(cents, 0, ".", ",");
    //     case "amount_with_apostrophe_separator":
    //       return formatWithDelimiters(cents, 2, "'", ".");
    //     case "amount_no_decimals_with_space_separator":
    //       return formatWithDelimiters(cents, 0, " ");
    //     case "amount_with_space_separator":
    //       return formatWithDelimiters(cents, 2, " ", ",");
    //     case "amount_with_period_and_space_separator":
    //       return formatWithDelimiters(cents, 2, " ", ".");
    //     default:
    //       return match;
    //   }
    // });
}
